export type ID = number | string;

export interface APIPaginatedResponse<T> {
  count: number;
  next: string | null;
  previous: string | null;
  results: T[];
}

/**
 * Enum of API error codes returned in the error response body.
 * @enum {string}
 */
export enum ApiErrorCodes {
  TimeFrameError = "DINE-5002",
  PinProtectionRequired = "DINE-1001",
}

export enum EndpointService {
  Core = "core",
  Gateway = "gateway",
  Reports = "reports",
}
